<template>
  <v-form>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <church-select
      v-model="churchID"
      id="churchID"
    />
    <v-btn
      @click="submit"
      id="submit"
    >Update Role Data</v-btn>
  </v-form>
</template>

<script>
import ChurchSelect from './church-select'

export default {
  name: 'SetupChurchStaff',
  data: () => ({
    _userID: null,
    churchID: null,
    isError: false,
    errMessage: null
  }),
  props: {
    userID: {
      type: String,
      default: null
    }
  },
  watch: {
    userID: function () {
      this._userID = this.userID
    }
  },
  methods: {
    submit: function () {
      var _this = this
      this.axios.post('/churches/' + this.churchID + '/staff/' + this._userID)
        .then(function () {
          // XXX: Note success?
        })
        .catch(this.$root.apiErrorHandler(function (msg) {
          _this.errMessage = msg
          _this.isError = true
        }))
    }
  },
  mounted () {
    // Make sure that our internal userID value starts out as equal with our prop value
    this._userID = this.userID

    // Try to load existing data for the user if appropriate
    if (this._userID !== null) {
      let _this = this
      this.axios.get('/auth/users/' + this._userID)
        .then(function (res) {
          if (res.data && res.data.length > 0) {
            let user = res.data[0]
            if (user.churchID) {
              _this.churchID = user.churchID
            }
          }
        })
        .catch(this.$root.apiErrorHandler())
    }
  },
  components: {
    ChurchSelect
  }
}
</script>
